import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';

const Solicitacoes = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();
  const [requisoes, setRequisicoes] = useState([]);
  const [itensRequisicoes, setItensRequisicoes] = useState({});
  const [expanded, setExpanded] = useState({}); // Controla o estado de expansão

  useEffect(() => {
    // Navega para a página inicial se o usuário não estiver logado
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    const fetchRequisicoes = async () => {
      try {
        const response = await fetch(`${userInfo.url}/almoxarifado/departamento/${userInfo.dpc_id}`,{
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
          },  
        });
        if (!response.ok) {
          throw new Error('Erro ao buscar as requisições de almoxarifado.');
        }
        const data = await response.json();
        setRequisicoes(data);
      } catch (error) {
        console.error('Erro ao buscar requisições:', error);
      }
    };

    fetchRequisicoes();
  },);

  const fetchItensRequisicao = async (almId) => {
    try {
      const response = await fetch(`${userInfo.url}/produto/almoxarifado/${almId}`,{
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
          },
    });
      if (!response.ok) {
        throw new Error(`Erro ao buscar itens da requisição.`);
      }
      const data = await response.json();
      // Relaciona o alm_id com os itens (assumindo que data já é um array)
      setItensRequisicoes((prev) => ({ ...prev, [almId]: data }));
    } catch (error) {
      console.error(`Erro ao buscar itens da requisição ${almId}:`, error);
    }
  };
  

  const toggleExpand = (almId) => {
    setExpanded((prev) => ({ ...prev, [almId]: !prev[almId] }));

    // Carregar os itens se ainda não estiverem carregados
    if (!itensRequisicoes[almId]) {
      fetchItensRequisicao(almId);
    }
  };

  return (
    <>
      <header className="header">
        <h2>Bem-vindo, {userInfo?.username}!</h2>
        <h3>Empresa: {userInfo?.company}</h3>
        <h1>Consulta e Acompanhamento das Requisiçãoes de Insumos</h1>
      </header>
      <Link to="/menu" className="link-style">Voltar ao menu</Link>
      <div className="container-solicitacao">
        {requisoes.map((requisicao) => (
          <div key={requisicao.almId} className="requisicao-item">
            <div className="requisicao-header">
              <button onClick={() => toggleExpand(requisicao.almId)}>
                {expanded[requisicao.almId] ? '-' : '+'}
              </button>
                <div className="info-container">
                  <div className="info-header">
                    <span className="info-bold">ID: {requisicao.almId} - {requisicao.almDescricao}</span>
                  </div>
                  <div className="info-details">
                    <span>Data Solicitado: {requisicao.almDtaCadastro}<br></br>
                    ID Funcionario: {requisicao.usuId} - {requisicao.solicitante}<br></br>
                    Situação: {requisicao.almStatus}</span>
                  </div>
              </div>
            </div>
            {expanded[requisicao.almId] && (
              <div className="itens-requisicao">
                {itensRequisicoes[requisicao.almId] ? (
                  itensRequisicoes[requisicao.almId].map((item) => (
                    <div key={item.proCodInterno} className="item">
                      <span>{item.proDescricao}</span>
                      <span>Quantidade: {item.ialmQtd}</span>
                    </div>
                  ))
                ) : (
                  <span>Carregando itens...</span>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default Solicitacoes;